import axios from "axios";

export const BRANCH_URL = "/Branch";

/** Belli Bir Branş Listesini Elde Eder */
export function getBranches(queryParams) {
  return axios.post(`${BRANCH_URL}/GetBranches`, queryParams);
}

/** Belli Bir Branş Listesini Sayfalama Olmadan Elde Eder */
export function getAllBranches(queryParams) {
  return axios.post(`${BRANCH_URL}/GetAllBranches`, queryParams);
}

/** Yeni Bir Branş Elde Eder */
export function getNewBranch() {
  return axios.get(BRANCH_URL);
}

/** Belli Bir Branşı Elde Eder */
export function getBranch(id) {
  return axios.get(`${BRANCH_URL}/${id}`);
}

/** Belli Bir Branşı Kaydeder */
export function saveBranch(branch) {
  return axios.post(BRANCH_URL, branch);
}

/** Belli Bir Branş Listesini Siler */
export function deleteBranches(ids) {
  return axios.post(`${BRANCH_URL}/Delete`, { ids });
}